import React, { useState } from 'react';
import { Button, Card } from '../../shared/components';
import ExamRunner from './ExamRunner';
import './Exams.css';

export default function Exams() {
  const [started, setStarted] = useState(false);

  if (started) {
    return <ExamRunner onExit={() => setStarted(false)} />;
  }

  return (
    <div className="exams-page">
      <h1>Full Practice Exam</h1>
      <Card className="exams-intro-card">
        <p>
          This simulates the real digital SAT format: a timed, full-length set of questions drawn
          proportionally from every domain, with a raw score and section breakdown.
        </p>
        <ul>
          <li>~134 minutes</li>
          <li>98 questions, weighted by domain</li>
          <li>No pass/fail cutoff &mdash; the real SAT is scored 400&ndash;1600, not graded pass/fail</li>
        </ul>
        <p className="exams-disclaimer">
          Every question here is AI-generated original content written in the style and format of the digital
          SAT &mdash; not actual College Board exam questions. The College Board copyrights its exam questions and
          prohibits reproducing them, so this exam is a close simulation of what to expect, not a real or leaked exam.
        </p>
        <Button onClick={() => setStarted(true)}>Start timed exam</Button>
      </Card>
    </div>
  );
}
